import { render } from "./FooterDesk.vue?vue&type=template&id=13a41bfc&scoped=true"
import script from "./FooterDesk.vue?vue&type=script&lang=js"
export * from "./FooterDesk.vue?vue&type=script&lang=js"

import "./FooterDesk.vue?vue&type=style&index=0&id=13a41bfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a41bfc"]])

export default __exports__